<template>
  <v-card style="margin-bottom:1em" class="UsuarioFuncionarioFiltros">
    <v-card-title>
      <span class="title">{{ $tc('title.filtro', 2) }}</span>
      <v-spacer></v-spacer>
      <v-icon v-show="filtrosAbertos"
        @click="fixaFiltros"
        :class="filtrosFixosClass">
        fa-thumbtack
      </v-icon>
      <v-badge
      bordered
      color="orange"
      icon="mdi-lock"
      overlap
      v-if="habilitaIconBadge">
      <v-icon @click="toggleFiltros">filter_list</v-icon>
    </v-badge>
    <v-icon v-else @click="toggleFiltros">filter_list</v-icon>
    </v-card-title>
    <v-container fluid grid-list-md v-show="filtrosAbertos">
      <v-row :class="layoutClass">
        <v-col cols="12" sm="6" md="3">
          <v-text-field
            v-model="filtrosUsuarioFuncionario.nome"
            :label="$tc('label.nome',1)"
            clearable hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
            v-model="filtrosUsuarioFuncionario.email"
            :label="$tc('label.email',1)"
            clearable hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-text-field
            v-model="filtrosUsuarioFuncionario.login"
            :label="$tc('label.login',1)"
            clearable hide-details
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            v-model="filtrosUsuarioFuncionario.perfis"
            class="custom-autocomplete"
            :items="listaPerfis"
            item-text="nomPerfil"
            item-value="id"
            :label="$tc('label.perfil',1)"
            multiple
            chips
            deletable-chips
            clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            id="usuario-idDivisao"
            v-model="filtrosUsuarioFuncionario.divisoes"
            :items="listaDivisoes"
            item-text="nome"
            item-value="id"
            :label="$tc('label.divisao',1)"
            @click:append="() => triggerSelecao('usuario-idDivisao')"
            multiple
            chips
            deletable-chips
            clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            v-model="filtrosUsuarioFuncionario.ativos"
            :items="listaAtivos"
            item-value="ativo"
            :label="`${$tc('label.ativo', 1)}`"
            multiple
            chips
            deletable-chips
            clearable
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-autocomplete
            id="usuario-idEstruturaUsuario"
            v-model="filtrosUsuarioFuncionario.idEstruturaUsuario"
            :items="listaEstruturaUsuarios"
            :no-data-text="$tc('message.nenhum_registro', 1)"
            item-text="nomEstruturaUsuario"
            item-value="id"
            :label="`${$tc('label.estrutura_usuario', 1)}`"
            @click:append="() => triggerSelecao('usuario-idEstruturaUsuario')"
            chips
            clearable>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-switch v-model="filtrosUsuarioFuncionario.indUsuariosAguardandoComplementoCadastro" :label="$t('label.exibir_usuarios_aguardando_complemento_cadastro')">
          </v-switch>
        </v-col>
      </v-row>
    </v-container>
    <v-card-actions v-show="filtrosAbertos">
      <v-spacer></v-spacer>
      <v-btn @click="resetaFiltros"
        color="accent"
      >{{$t('label.limpar_filtros')}}</v-btn>
      <v-btn @click="aplicarFiltros"
        color="primary"
      >{{$t('label.filtrar')}}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { mapGetters } from 'vuex';
import {
  triggerSelecao,
} from '@/common/functions/autocomplete-utils';
import { copyObject } from '@/common/functions/helpers';

export default {
  name: 'UsuarioFuncionarioFiltros',
  mixins: [

  ],
  props: {
  },
  computed: {
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    ...mapGetters('roles', [
      'getTenantId',
    ]),
    isTenantEpoca() {
      return this.getTenantId === 'epoca';
    },
    isTenantMagalu() {
      return this.getTenantId === 'magalu';
    },
    isTenantKabum() {
      return this.getTenantId === 'kabum';
    },
    filtrosFixosClass() {
      return {
        'primary--text': this.filtrosFixados,
        'mr-2': true,
      };
    },
  },
  data() {
    return {
      workspaceFiltrosResources: this.$api.workspaceFiltros(this.$resource),
      perfilResource: this.$api.perfil(this.$resource),
      divisaoResources: this.$api.divisao(this.$resource),
      estruturaUsuarioResource: this.$api.estruturaUsuario(this.$resource),
      filtrosAbertos: false,
      filtrosFixados: false,
      workspace: {},
      entidadeWorkspace: 'gestao_usuario_funcionario',
      habilitaIconBadge: false,
      layoutClass: { wrap: true },
      filtrosUsuarioFuncionario: {},
      listaPerfis: [],
      listaDivisoes: [],
      listaAtivos: [
        { ativo: true, text: 'Sim' },
        { ativo: false, text: 'Não' },
      ],
      listaEstruturaUsuarios: [],
    };
  },
  methods: {
    triggerSelecao,
    carregarWorkspaceFiltros() {
      const entidade = this.entidadeWorkspace;
      this.workspaceFiltrosResources.pesquisar({ entidade })
        .then((response) => {
          this.workspace = response.data || {};
          this.filtrosFixados = this.workspace.indAberto || false;
          this.filtrosAbertos = this.filtrosFixados;
          this.filtrosUsuarioFuncionario = this.workspace.filtros || {};
          if (Object.values(this.filtrosUsuarioFuncionario).length > 0) {
            this.habilitaFlagBadge(true);
          }
          setTimeout(() => this.restaurarFiltros());
        }).catch((err) => {
          this.$error(this, err);
        }).finally(() => {
          this.carregouCampos = true;
        });
    },
    toggleFiltros() {
      this.filtrosAbertos = !this.filtrosAbertos;
    },
    fixaFiltros() {
      this.filtrosFixados = !this.filtrosFixados;
      this.workspace.indAberto = this.filtrosFixados;
      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
    inserirWorkspace() {
      const entidade = this.entidadeWorkspace;
      this.workspaceFiltrosResources
        .inserir({ entidade }, this.workspace)
        .then((response) => {
          this.workspace.id = response.data;
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    atualizarWorkspace() {
      const entidade = this.entidadeWorkspace;
      this.workspaceFiltrosResources
        .atualizar({ entidade }, this.workspace)
        .catch((err) => {
          this.$error(this, err);
        });
    },
    resetaFiltros() {
      this.filtrosUsuarioFuncionario = {};
      this.habilitaIconBadge = false;
      setTimeout(() => this.aplicarFiltros());
    },
    restaurarFiltros() {
      const params = this.validaFiltros();
      this.$emit('UsuarioFuncionarioFiltros__AplicaFiltros', params);
    },
    validaFiltros() {
      const parametros = copyObject(this.filtrosUsuarioFuncionario);

      Object.keys(parametros).forEach((param) => {
        if (parametros[param] === null) {
          delete parametros[param];
        }
      });

      return parametros;
    },
    aplicarFiltros() {
      this.salvarFiltrosWorkspace();
      this.restaurarFiltros();
    },
    salvarFiltrosWorkspace() {
      this.verificaCamposPreenchidosBadge();

      this.workspace.filtros = {
        ...this.filtrosUsuarioFuncionario,
      };

      if (!this.workspace.id) {
        this.inserirWorkspace();
      } else {
        this.atualizarWorkspace();
      }
    },
    verificaCamposPreenchidosBadge() {
      const filtroUsuario = this.validaFiltros();
      const filtroUsuarioValores = Object.values(filtroUsuario);
      this.habilitaBadge(filtroUsuarioValores);
    },
    habilitaBadge(filtroUsuario) {
      if (filtroUsuario.length !== 0) {
        filtroUsuario.forEach((item) => {
          if ((typeof item !== 'boolean' && typeof item !== 'number' && !item.length)) {
            this.countFiltro += 1;
          }
        });
        if (filtroUsuario.length === this.countFiltro) {
          this.filtrosUsuarioFuncionario = {};
          this.habilitaFlagBadge(false);
        } else {
          this.habilitaFlagBadge(true);
        }
        this.countFiltro = 0;
      } else {
        this.habilitaFlagBadge(false);
      }
    },
    habilitaFlagBadge(valor) {
      this.habilitaIconBadge = valor;
    },
    aplicaModelo(selecaoAtual) {
      if (this.multiplaEscolha) {
        this.itens = [...selecaoAtual];
      } else {
        this.itens.push(selecaoAtual);
      }
    },
    buscarPerfis(content = '') {
      const params = {
        autocomplete: content,
        limit: 1000,
        page: 0,
      };
      return this.perfilResource.selecao(params)
        .then((res) => {
          if (res.data) {
            this.listaPerfis = res.data;
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarDivisoes(content = '') {
      const param = {
        autocomplete: content,
        limit: 10000,
      };
      return this.divisaoResources.selecao(param)
        .then((res) => {
          if (res.data) {
            this.listaDivisoes = res.data;
          }
        })
        .catch((err) => {
          this.$error(this, err);
        });
    },
    buscarEstruturasUsuario(content) {
      const param = {
        autocomplete: content,
        limit: 10000,
      };
      return this.estruturaUsuarioResource.selecao(param)
        .then((res) => {
          this.listaEstruturaUsuarios = res.data;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    clickEstruturaUsuario() {
      this.buscarEstruturasUsuario(this.searchInputEstrutura);
    },
  },
  beforeMount() {
    Promise.all([
      this.buscarPerfis(),
      this.buscarDivisoes(),
      this.buscarEstruturasUsuario(),
    ]);
  },
  mounted() {
    this.carregarWorkspaceFiltros();
  },
};
</script>
<style>
  .UsuarioFuncionarioFiltros__Autocomplete .chip--select-multi .v-chip__content span.trunc-ellipsis {
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    width: 150px;
  }
  .UsuarioFuncionarioFiltros__Autocomplete .chip--select-multi {
    width: 195px;
  }
</style>
